import React from 'react';
import { Star } from 'lucide-react';

export const KurzErklaertBewertungen = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="bg-brand-green/5 border-l-4 border-brand-green rounded-r-3xl p-10 lg:p-12 shadow-lg">
          <div className="flex items-start gap-6">
            <div className="flex-shrink-0">
              <div className="w-14 h-14 bg-brand-green/10 rounded-2xl flex items-center justify-center border border-brand-green/15">
                <Star className="w-7 h-7 text-brand-green" />
              </div>
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-bold text-brand-green-dark mb-4">Kurz erklärt</h2>
              <p className="text-gray-700 leading-relaxed text-lg">
                Bewertungen geben einen Eindruck von Kommunikation, Ablauf und Zuverlässigkeit. Für uns steht eine sachliche, nachvollziehbare Begutachtung im Vordergrund.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};